import React from "react";

import { OrderStatus } from "../../../constants";
import { useAppSelector } from "../../../store/reducers";
import * as signals from "../../../store/signals";

export const PaymentDeclineTracker = (): React.ReactNode => {
    const isDeclined = useAppSelector(
        (state) =>
            state.checkout.data.payment_states?.order_status ===
            OrderStatus.PAYMENT_DECLINED,
    );
    const prevDeclinedRef = React.useRef(false);

    React.useEffect(() => {
        if (isDeclined && !prevDeclinedRef.current) {
            signals.checkout.onPaymentDecline.emit();
        }
        prevDeclinedRef.current = isDeclined;
    }, [isDeclined]);

    return null;
};
